import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { Children, useCallback, useMemo } from "react";
import { useBoolean } from "usehooks-ts";
import Icon from "../../../../../base/icons/icon/index.js";
import Image from "../../../../../base/multimedia/image/index.js";
import JsonLd from "../../../../../base/others/json-ld/index.js";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import SearcherActivitiesMobile from "../../../../searchers/searcher-activities/views/mobile/index.js";
import { nullsToUndefined } from "../../../../../../helpers/null.js";
import { SearcherId } from "../../../../../../types/common/searchers.js";
import { getReviewContent, ratingTemplate } from "../../utils/index.js";
import { ImageResize, MAX_UPSIDE as MAX_UPSIDES } from "../../utils/constants.js";
import HeaderBadges from "./header-badges/index.js";
import Prices from "./prices/index.js";
import * as S from "./styled.js";
const ProductCardMobileView = ({ title ='' , textInfo , subtitle , detail , descriptions =[] , price , rating , image , link , className ='' , ldjson , config ={} , upside =[] , promotion , tripadvisor , reviews , transport , icons =[] , company , searcher , defaultImage ={}  })=>{
    const { literals , rating: ratingIco = 'star' , zone =false , deal =false , showSubtitleFirst =false , isBlackfriday =false , soldOut =false , hasModal =false , showDescriptionFirst =false , isFirstComponent =false  } = config;
    const reviewContent = getReviewContent(reviews);
    const jsonLd = ldjson && 'scripts' in ldjson ? [
        ldjson
    ] : ldjson?.scripts || [];
    const transports = transport && Array.isArray(transport) ? transport : [
        transport ?? ''
    ];
    const { value: isVisible , toggle: toggleVisibility  } = useBoolean();
    const imagePropertiesMobile = {
        ...ImageResize.MOBILE,
        ...defaultImage,
        isLazy: !isFirstComponent
    };
    const imagePropertiesMobileCompany = {
        ...ImageResize.MOBILE_COMPANY,
        ...defaultImage,
        isLazy: !isFirstComponent
    };
    const subtitleItem = useMemo(()=>/*#__PURE__*/ _jsx(_Fragment, {
            children: subtitle && /*#__PURE__*/ _jsxs(S.Subtitle, {
                children: [
                    textInfo && /*#__PURE__*/ _jsx("span", {
                        className: "product-card-textInfo",
                        children: textInfo
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "product-card-subtitle",
                        children: subtitle
                    }),
                    ratingTemplate(!zone, ratingIco, rating)
                ]
            })
        }), [
        subtitle,
        zone,
        ratingIco,
        rating,
        textInfo
    ]);
    const onClickCard = useCallback((event)=>{
        if (hasModal) {
            event.preventDefault();
            toggleVisibility();
        }
    }, [
        hasModal,
        toggleVisibility
    ]);
    const renderSearcher = (id)=>{
        const searcherProps = {
            name: 'm-productcardmodal-searcher',
            props: searcher
        };
        if (id === SearcherId.ACTIVITIES) {
            return /*#__PURE__*/ _jsx(SearcherActivitiesMobile, {
                ...searcherProps
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(S.ProductCardBox, {
                "data-testid": "ProductCard",
                className: classNames({
                    [className]: !!className,
                    'is-sold-out': soldOut
                }),
                children: [
                    /*#__PURE__*/ _jsx(HeaderBadges, {
                        config: config,
                        discount: price?.discount
                    }),
                    /*#__PURE__*/ _jsxs(S.ProductCardLink, {
                        ...nullsToUndefined(link),
                        children: [
                            /*#__PURE__*/ _jsxs(S.ProductCardImageContainer, {
                                onClick: onClickCard,
                                children: [
                                    image && /*#__PURE__*/ _jsx(Image, {
                                        className: "itinerary",
                                        ...imagePropertiesMobile,
                                        ...image
                                    }),
                                    company && /*#__PURE__*/ _jsx(Image, {
                                        className: "logo",
                                        ...imagePropertiesMobileCompany,
                                        ...company
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(S.ProductCardContent, {
                                children: [
                                    /*#__PURE__*/ _jsxs(S.ProductCardHeader, {
                                        onClick: onClickCard,
                                        children: [
                                            showSubtitleFirst && subtitleItem,
                                            /*#__PURE__*/ _jsxs(S.ProductCardTitle, {
                                                children: [
                                                    title,
                                                    ratingTemplate(zone, ratingIco, rating)
                                                ]
                                            }),
                                            !showSubtitleFirst && subtitleItem,
                                            detail && /*#__PURE__*/ _jsx(S.Detail, {
                                                tag: "p",
                                                content: detail
                                            }),
                                            showDescriptionFirst && !!descriptions.length && /*#__PURE__*/ _jsx(S.Descriptions, {
                                                className: classNames({
                                                    'is-deal': deal
                                                }),
                                                children: Children.toArray(descriptions.map((item)=>/*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                                                        tag: "p",
                                                        content: item
                                                    })))
                                            }),
                                            !!upside.length && /*#__PURE__*/ _jsx(S.Upside, {
                                                children: Children.toArray(upside.slice(0, MAX_UPSIDES).map((item)=>/*#__PURE__*/ _jsx("p", {
                                                        children: item
                                                    })))
                                            }),
                                            promotion && /*#__PURE__*/ _jsx(S.Promotion, {
                                                children: /*#__PURE__*/ _jsx("p", {
                                                    children: promotion
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(S.ProductCardFooter, {
                                        onClick: onClickCard,
                                        children: [
                                            (!!tripadvisor || !!reviews || descriptions.length > 0 || !!icons || !transports) && /*#__PURE__*/ _jsxs(S.ProductCardDescription, {
                                                children: [
                                                    tripadvisor && /*#__PURE__*/ _jsx(S.Tripadvisor, {
                                                        ...tripadvisor,
                                                        width: 120,
                                                        height: 20
                                                    }),
                                                    !tripadvisor && !!reviews && /*#__PURE__*/ _jsxs(S.Reviews, {
                                                        className: `reviews-${reviewContent}`,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: literals?.[reviewContent]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Icon, {
                                                                className: "nico-thumbs-up-filled"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: reviews
                                                            })
                                                        ]
                                                    }),
                                                    !showDescriptionFirst && !!descriptions.length && /*#__PURE__*/ _jsx(S.Descriptions, {
                                                        className: classNames({
                                                            'is-deal': deal
                                                        }),
                                                        children: Children.toArray(descriptions.map((item)=>/*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                                                                tag: "p",
                                                                content: item
                                                            })))
                                                    }),
                                                    !!icons.length && /*#__PURE__*/ _jsx(S.ProductCardIconProps, {
                                                        children: Children.toArray(icons.slice(0, 3).map((item)=>/*#__PURE__*/ _jsx(Icon, {
                                                                className: `nico-${item.icon}`
                                                            })))
                                                    }),
                                                    transports && /*#__PURE__*/ _jsx(S.Transport, {
                                                        children: Children.toArray(transports.map((trans)=>/*#__PURE__*/ _jsx("p", {
                                                                children: trans
                                                            })))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Prices, {
                                                isDeal: deal,
                                                price: price,
                                                literals: literals,
                                                isBlackfriday: isBlackfriday
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    Children.toArray(jsonLd?.map((script)=>/*#__PURE__*/ _jsx(JsonLd, {
                            structuredData: script
                        })))
                ]
            }),
            hasModal && /*#__PURE__*/ _jsx(S.SearcherModal, {
                visible: isVisible,
                hide: toggleVisibility,
                content: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(S.Title, {
                            children: title
                        }),
                        renderSearcher('ACTIVITIES')
                    ]
                }),
                color: "primary",
                variant: "fullScreen",
                "data-testid": "CardProductModal"
            })
        ]
    });
};
export default ProductCardMobileView;

//# sourceMappingURL=index.js.map